// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bf78fbb4","498":"d8ffe0ea","703":"87530d56","787":"01aa6fed"}[chunkId] + ".chunk.js";
};